var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.825,
    height: 23.818,
    viewBox: "0 0 21.825 23.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-115.695 -600.453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.842,619.725a10.316,10.316,0,1,1,.71-13.8l.384-.384c-.223-.27-.458-.534-.711-.786a10.857,10.857,0,1,0,0,15.355Z",
    transform: "translate(0 -0.012)",
    fill: "#161615",
    stroke: "#161615",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.615,601.552l.506,4.8-4.932.52",
    transform: "translate(-12.601)",
    fill: "none",
    stroke: "#161615",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewQuestion);
export default __webpack_public_path__ + "static/media/icon_new_question.a2cb9b081f52b0e658aaebb092acfdaa.svg";
export { ForwardRef as ReactComponent };